import getCurrentISOString from '@gef-ui/date-fns-utils/getCurrentISOString';
import { actionTypes } from '../constants';
export const errorReducer = (state, action)=>{
    switch(action.type){
        case actionTypes.ADD_ERROR:
            {
                return {
                    ...state,
                    errors: [
                        ...action.meta?.clearPrevious ? action.meta?.clearPrevious(state.errors) : state.errors,
                        {
                            ...action.payload,
                            uuid: crypto.randomUUID(),
                            timestamp: getCurrentISOString(),
                            sentSuccess: false,
                            sentFail: false
                        }
                    ]
                };
            }
        case actionTypes.REMOVE_ERROR:
            {
                return {
                    ...state,
                    errors: state.errors.filter((error)=>error.uuid !== action.payload.uuid)
                };
            }
        case actionTypes.HIDE_ERROR:
            {
                return {
                    ...state,
                    errors: state.errors.map((error)=>{
                        if (error.uuid !== action.payload.uuid) {
                            return error;
                        }
                        return {
                            ...error,
                            hidden: true
                        };
                    })
                };
            }
        case actionTypes.CLEAR_ERRORS:
            {
                return {
                    ...state,
                    errors: []
                };
            }
        case actionTypes.HIDE_ERRORS:
            {
                return {
                    ...state,
                    errors: state.errors.map((error)=>({
                            ...error,
                            hidden: true
                        }))
                };
            }
        case actionTypes.SHOW_ERRORS:
            {
                return {
                    ...state,
                    errors: state.errors.map((error)=>({
                            ...error,
                            hidden: false
                        }))
                };
            }
        case actionTypes.SHOW_ERROR_SINGLE:
            {
                return {
                    ...state,
                    isModalErrorVisible: true,
                    error: {
                        ...action.payload,
                        timestamp: getCurrentISOString()
                    }
                };
            }
        case actionTypes.CLOSE_ERROR_SINGLE:
            {
                return {
                    ...state,
                    isModalErrorVisible: false
                };
            }
        case actionTypes.REMOVE_ERROR_SINGLE:
            {
                return {
                    ...state,
                    error: undefined
                };
            }
        case actionTypes.SHOW_ERROR_MULTIPLE:
            {
                return {
                    ...state,
                    isModalMultipleErrorsVisible: true
                };
            }
        case actionTypes.CLOSE_ERROR_MULTIPLE:
            {
                return {
                    ...state,
                    isModalMultipleErrorsVisible: false
                };
            }
        case actionTypes.SENT_SUCCESSFULLY:
            {
                return {
                    ...state,
                    errors: state.errors.map((error)=>error.uuid === action.payload.uuid ? {
                            ...error,
                            sentSuccess: true
                        } : error)
                };
            }
        case actionTypes.SENT_FAILED:
            {
                return {
                    ...state,
                    errors: state.errors.map((error)=>error.uuid === action.payload.uuid ? {
                            ...error,
                            sentFail: true
                        } : error)
                };
            }
        case actionTypes.DELETE_SENT:
            {
                return {
                    ...state,
                    errors: state.errors.filter((error)=>!error.sentSuccess)
                };
            }
        case actionTypes.SHOW_ERROR_FULLSCREEN:
            {
                return {
                    ...state,
                    fullScreenError: {
                        ...action.payload,
                        timestamp: getCurrentISOString()
                    }
                };
            }
    }
};
